var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgTooltipArrowUp = function SvgTooltipArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24L12 6l12 18H0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24L12 6l12 18",
    stroke: "#EEE",
    strokeWidth: 2
  })));
};
export default SvgTooltipArrowUp;